<app-soft-deletable-auditable-lookups
  [paginationResponseResolver]="client"
  [defaultPaginationParameters]="defualtPaginationParameters"
  [supportedActions]="supportedActions"
  [tableConfig]="{
    fields: [
      { name: 'code', displayName: 'LOCATION_MANAGEMENT.CODE' },
      { name: 'phoneCode', displayName: 'LOCATION_MANAGEMENT.PHONE_CODE' },
      { name: 'currency', displayName: 'LOCATION_MANAGEMENT.CURRENCY' },
      { name: 'currencyCode', displayName: 'LOCATION_MANAGEMENT.CURRENCY_CODE' },
      { name: 'language', displayName: 'LOCATION_MANAGEMENT.LANGUAGE' },
      { name: 'flag', displayName: 'LOCATION_MANAGEMENT.FLAG' }
    ],
    template: tableRowTemplate
  }"
/>

<ng-template #tableRowTemplate let-element>
  <td>{{ element.code }}</td>
  <td>{{ element.phoneCode }}</td>
  <td>{{ element.currency }}</td>
  <td>{{ element.currencyCode }}</td>
  <td>{{ element.language }}</td>
  <td>{{ element.flag }}</td>
</ng-template>
